<template>
    <li>
        <p>Customer Name: <span> {{request.firstName}} {{request.lastName}}</span></p>
        <p>Customer's Contacts: <span>{{request.phoneNumber}}</span></p>
        <p>Product Owner: <span>{{request.ownerName}}</span></p>
        <p>Owner's contacts: <span>{{request.ownerPhoneNumber}}</span></p>
        <p>Product Name: <span>{{request.productName}}</span></p>
        <p>Product Price: <span>{{ request.price }}</span></p>
        <p>Date the request was sent: <span>{{ request.date }}</span></p>
        <router-link :to="productDetail">See property</router-link>
    </li>
</template>

<script>
export default {
    props: ['request'],
    computed: {
        emailLink() {
            return 'mailto:' + this.request.emailAddress
        },
        requestOwner() {
          console.log(this.$store.getters["marketplace/getProducts"].filter(product => product.id === this.request.productId))
            return this.$store.getters["marketplace/getProducts"].filter(product => product.id === this.request.productId)
        },
        productDetail() {
            console.log('the printing', this.request)
        return "/marketplace/product/" + this.request.productId;
    },
    }
}
</script>

<style scoped>
span {
  font-weight: bold;
}
li {
  margin: 1rem 0;
  border: 1px solid #ccc;
  padding: 1rem;
}

a {
  color: #3d008d;
  text-decoration: none;
  font-weight: bold;
}

a:hover,
a:active {
  color: #8d007a;
}

p {
  margin: 0.5rem 0 0 0;
}
</style>